import suggestionSecondaryActionSelected from '../actions/suggestionSecondaryActionSelected';
import updateNextSearchQueryId from '../actions/updateNextSearchQueryId';
import datapoints, { ButtonNames } from '../datapoints';
import { logUsage } from 'owa-analytics';
import { SearchScenarioId } from 'owa-search-next-common';
import { orchestrator } from 'satcheljs';
import {
    lazyLogSecondaryEntityActionClicked,
    SubstrateSearchScenario,
    Suggestion,
    FileSuggestion,
    EntityActionTakenType,
} from 'owa-search-service';

export default orchestrator(suggestionSecondaryActionSelected, actionMessage => {
    const {
        suggestion,
        suggestionIndex,
        suggestionSetTraceId,
        scenarioId,
        entityActionTakenType,
    } = actionMessage;

    switch (entityActionTakenType) {
        case 'Download':
            handleDownloadFileAction(
                suggestion as FileSuggestion,
                scenarioId,
                suggestionIndex,
                suggestionSetTraceId
            );
            break;
        case 'Share':
            handleShareFileAction(
                suggestion as FileSuggestion,
                scenarioId,
                suggestionIndex,
                suggestionSetTraceId
            );
            break;
        case 'OpenContactCard':
            handleOpenContactCardAction(
                suggestion,
                scenarioId,
                suggestionIndex,
                suggestionSetTraceId
            );
            break;
        default:
            break;
    }

    updateNextSearchQueryId(scenarioId);
});

function logActionClicked(
    scenarioId: SearchScenarioId,
    buttonName: ButtonNames,
    suggestionIndex: number,
    suggestion: Suggestion,
    suggestionSetTraceId: string,
    entityActionTakenType: EntityActionTakenType
) {
    const { name: eventName, customData: customData } = datapoints.Search_QuickActionClicked;
    logUsage(eventName, customData(buttonName, SearchScenarioId[scenarioId], suggestionIndex));

    // log if traceId is not null
    if (suggestionSetTraceId) {
        lazyLogSecondaryEntityActionClicked.importAndExecute(
            new Date(),
            suggestionSetTraceId,
            suggestion.ReferenceId,
            'EntityActionTaken',
            SubstrateSearchScenario.Mail,
            entityActionTakenType
        );
    }
}

function handleDownloadFileAction(
    fileSuggestion: FileSuggestion,
    scenarioId: SearchScenarioId,
    suggestionIndex: number,
    suggestionSetTraceId: string
) {
    /**
     * Work Item 51737: Implement handlers for download/share quick actions
     * Re-implement the orchestrator for this flow. It was intentionally
     * left out since the actions add to boot and we won't be able to experiment
     * with this feature for a while.
     */
    // downloadFileSuggestion(fileSuggestion.AttachmentId, fileSuggestion.Attachment, scenarioId);

    logActionClicked(
        scenarioId,
        'DownloadFile',
        suggestionIndex,
        fileSuggestion,
        suggestionSetTraceId,
        'Download'
    );
}

function handleShareFileAction(
    fileSuggestion: FileSuggestion,
    scenarioId: SearchScenarioId,
    suggestionIndex: number,
    suggestionSetTraceId: string
) {
    /**
     * Work Item 51737: Implement handlers for download/share quick actions
     * Re-implement the orchestrator for this flow. It was intentionally
     * left out since the actions add to boot and we won't be able to experiment
     * with this feature for a while.
     */
    // shareFileSuggestion(fileSuggestion.AttachmentId, fileSuggestion.Attachment, scenarioId);

    logActionClicked(
        scenarioId,
        'ShareFile',
        suggestionIndex,
        fileSuggestion,
        suggestionSetTraceId,
        'Share'
    );
}

function handleOpenContactCardAction(
    suggestion: Suggestion,
    scenarioId: SearchScenarioId,
    suggestionIndex: number,
    suggestionSetTraceId: string
) {
    logActionClicked(
        scenarioId,
        'ContactCard',
        suggestionIndex,
        suggestion,
        suggestionSetTraceId,
        'OpenContactCard'
    );
}
